var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooth13(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66.91 184.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m36.69,183.69c-9.37,0-14.06,0-21.09-4.69-7.03-4.69-16.4-9.37-14.06-21.09,2.34-11.72,7.03-35.15,11.72-42.18,4.69-7.03,4.69-32.81,4.69-32.81l7.03-51.56L29.66,3.25s4.69-9.37,9.37,11.72c4.69,21.09,16.4,77.33,16.4,82.02,0,4.69,2.34,23.43,7.03,32.81,4.69,9.37,4.69,39.84-2.34,44.53-7.03,4.69-14.06,9.37-23.43,9.37Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m34.35,162.6s0,4.69-4.69,7.03c-4.69,2.34-9.37,2.34-14.06,2.34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m50.75,167.29s-11.72,2.34-14.06,2.34-2.34,0-4.69,4.69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m50.75,122.76s-14.06-9.37-30.46-4.69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooth13);
export default __webpack_public_path__ + "static/media/tooth-13.171cabe4f4a36104e85ae0e357ff9f57.svg";
export { ForwardRef as ReactComponent };